/* SweetMenorca: botones "Elegir idioma y comprar" (data-gl-buy) de la guia digital.
   Antes apuntaban a "#" y no hacian nada. Ahora llevan al selector de idioma y al
   boton de compra nativo del producto (misma compra y mismo checkout de Shopify). */
(function () {
  var PRODUCT_URL = '/products/guia-digital-de-viaje-a-menorca-2026';

  function findTarget() {
    return document.querySelector('variant-selects') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-gl-buy]') : null;
    if (!btn) return;
    e.preventDefault();

    var target = findTarget();
    if (!target) {
      // Sin selector en esta pagina (p. ej. vista rapida): ir a la ficha del producto.
      window.location.href = PRODUCT_URL;
      return;
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    setTimeout(function () {
      var first = target.querySelector('input[type="radio"]:checked, input[type="radio"], select, button');
      if (first && first.focus) { try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); } }
    }, reduce ? 0 : 500);
  });
})();
